import { IRoleResponse } from '../models/role.model'
import { useRoleUseCase } from '../useCases/useRole.usecase'

export const useRoleContainer = (): IRoleResponse => {
  const { data, isLoading, activePolicies, handleOnCheckBoxChange, refetch } =
    useRoleUseCase()

  return { data, isLoading, activePolicies, handleOnCheckBoxChange, refetch }
}
